/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import Check from '@mui/icons-material/Check';
import CheckBox from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';

import { Typo } from 'uikit/content';

// DROPDOWN

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <ArrowDropDown sx={{ height: 18, width: 18 }} />
  </components.DropdownIndicator>
);

// OPTIONS

// NAVIGATOR OPTION

const NavigatorOption = (props) => (
  <components.Option {...props}>
    <Typo
      variant="b01"
      element="span"
    >
      {props.children}
    </Typo>
    {props.isSelected && (<Check sx={{ height: 18, width: 18 }} />)}
  </components.Option>
);

NavigatorOption.propTypes = {
  children: PropTypes.node.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

// FILTER OPTION

const FilterOption = (props) => (
  <components.Option {...props}>
    {props.isSelected ? (
      <CheckBox sx={{ height: 18, width: 18 }} />
    ) : (
      <CheckBoxOutlineBlank sx={{ height: 18, width: 18 }} />
    )}
    <Typo variant="b01" element="span">
      {props.children}
    </Typo>
  </components.Option>
);

FilterOption.propTypes = {
  children: PropTypes.node.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

// PLACEHOLDERS

// NAVIGATOR

const NavigatorPlaceholder = (props) => (
  <components.Placeholder {...props}>
    <Typo variant="s03">
      {props.children}
    </Typo>
  </components.Placeholder>
);

NavigatorPlaceholder.propTypes = {
  children: PropTypes.node.isRequired,
};

// FILTER

const FilterPlaceholder = (props) => (
  <components.Placeholder {...props}>
    <Typo variant="s02">
      {props.children}
    </Typo>
  </components.Placeholder>
);

FilterPlaceholder.propTypes = {
  children: PropTypes.node.isRequired,
};

// VALUES

// MULTI

const MultiValue = (props) => {
  const lastOption = props.selectProps.value[0] || props.selectProps.options[0];
  const lastOptionLabel = lastOption.label;
  const remainingOptionsCount = props.selectProps.value.length;
  const { value } = props.data;

  if (value !== lastOption.value) return null;

  return (
    <components.MultiValue {...props}>
      <Typo
        variant="s02"
        weight={(props.isFocused || props.hasValue) ? 'medium' : ''}
      >
        {lastOptionLabel}
      </Typo>
      <Typo variant="s02">
        {`(+${remainingOptionsCount})`}
      </Typo>
    </components.MultiValue>
  );
};

MultiValue.propTypes = {
  selectProps: PropTypes.shape({
    value: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      value: PropTypes.any,
    })),
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      value: PropTypes.any,
    })),
  }).isRequired,
  data: PropTypes.shape({
    value: PropTypes.any,
  }).isRequired,
  isFocused: PropTypes.bool.isRequired,
  hasValue: PropTypes.bool.isRequired,
};

// NAVIGATOR SINGLE

const NavigatorSingleValue = (props) => (
  <components.SingleValue {...props}>
    <Typo
      variant="s03"
      weight={(props.isFocused || props.hasValue) ? 'medium' : ''}
    >
      {props.children}
    </Typo>
  </components.SingleValue>
);

NavigatorSingleValue.defaultProps = {
  isFocused: false,
};

NavigatorSingleValue.propTypes = {
  isFocused: PropTypes.bool,
  hasValue: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

// FILTER SINGLE

const FilterSingleValue = (props) => (
  <components.SingleValue {...props}>
    <Typo
      variant="s02"
      weight={(props.isFocused || props.hasValue) ? 'medium' : ''}
    >
      {props.children}
    </Typo>
  </components.SingleValue>
);

FilterSingleValue.defaultProps = {
  isFocused: false,
};

FilterSingleValue.propTypes = {
  isFocused: PropTypes.bool,
  hasValue: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export {
  DropdownIndicator,
  NavigatorOption,
  FilterOption,
  NavigatorPlaceholder,
  FilterPlaceholder,
  MultiValue,
  NavigatorSingleValue,
  FilterSingleValue,
};
